import { useFranchise } from '~/shared/utils';
import { runtimeConfig } from '~/shared/utils/public-variables';

const { COMMERCE_URL } = runtimeConfig();

export const useStorePaths = () => {
    const { franchiseAPIPath } = useFranchise();
    const storesPath = `${COMMERCE_URL}/${franchiseAPIPath}/store/stores`;
    const reservationsPath = `${storesPath}/reservations`;
    const countPath = `${storesPath}/count`;

    return {
        storesPath,
        reservationsPath,
        countPath,
    };
};
